import createCardListingView from '../Views/createCardListingView';
import FlexThesisCard from './FlexThesisCard';

// Was a semantic-ui <Card.Group> that only carried the shared
// `cards__container` class when Grid layout was on - so in the default
// mode theses fell out of the site's card grid and used semantic's own
// flex-wrap layout instead. Now the same container as every other listing.
export default createCardListingView(FlexThesisCard, {
  displayName: 'ThesisListingView',
  useContainer: true,
});
